// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"274":"Home","376":"Empresa","389":"404","893":"Produtos"}[chunkId] + "." + {"274":"eb05172c","376":"0c4911f4","389":"9fc43682","893":"96b375a5"}[chunkId] + ".js";
};